"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.define-property.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-prototype-of.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.reflect.to-string-tag.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ICON_NAV_BAR_CLASSES = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.function.name.js");
require("core-js/modules/es.object.set-prototype-of.js");
require("core-js/modules/es.string.link.js");
var _react = _interopRequireWildcard(require("react"));
require("./IconNavBarStyle.css");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function cov_23vxb60gl8() {
  var path = "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/IconNavBar.tsx";
  var hash = "f48ba5675c0b0685dbcbb3513c78361bdc46520a";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/deprecated/UNSAFE_layout/IconNavBar.tsx",
    statementMap: {
      "0": {
        start: {
          line: 22,
          column: 36
        },
        end: {
          line: 28,
          column: 1
        }
      },
      "1": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 37,
          column: 6
        }
      },
      "2": {
        start: {
          line: 35,
          column: 63
        },
        end: {
          line: 35,
          column: 90
        }
      },
      "3": {
        start: {
          line: 41,
          column: 79
        },
        end: {
          line: 41,
          column: 89
        }
      },
      "4": {
        start: {
          line: 42,
          column: 16
        },
        end: {
          line: 42,
          column: 33
        }
      },
      "5": {
        start: {
          line: 45,
          column: 6
        },
        end: {
          line: 48,
          column: 12
        }
      },
      "6": {
        start: {
          line: 51,
          column: 4
        },
        end: {
          line: 53,
          column: 5
        }
      },
      "7": {
        start: {
          line: 52,
          column: 6
        },
        end: {
          line: 52,
          column: 46
        }
      },
      "8": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 56,
          column: 5
        }
      },
      "9": {
        start: {
          line: 55,
          column: 6
        },
        end: {
          line: 55,
          column: 54
        }
      },
      "10": {
        start: {
          line: 58,
          column: 24
        },
        end: {
          line: 62,
          column: 5
        }
      },
      "11": {
        start: {
          line: 59,
          column: 6
        },
        end: {
          line: 61,
          column: 7
        }
      },
      "12": {
        start: {
          line: 60,
          column: 8
        },
        end: {
          line: 60,
          column: 47
        }
      },
      "13": {
        start: {
          line: 64,
          column: 4
        },
        end: {
          line: 77,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 32,
            column: 3
          }
        },
        loc: {
          start: {
            line: 32,
            column: 18
          },
          end: {
            line: 38,
            column: 3
          }
        },
        line: 32
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 35,
            column: 36
          },
          end: {
            line: 35,
            column: 37
          }
        },
        loc: {
          start: {
            line: 35,
            column: 63
          },
          end: {
            line: 35,
            column: 90
          }
        },
        line: 35
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 40,
            column: 2
          },
          end: {
            line: 40,
            column: 3
          }
        },
        loc: {
          start: {
            line: 40,
            column: 56
          },
          end: {
            line: 78,
            column: 3
          }
        },
        line: 40
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 58,
            column: 24
          },
          end: {
            line: 58,
            column: 25
          }
        },
        loc: {
          start: {
            line: 58,
            column: 30
          },
          end: {
            line: 62,
            column: 5
          }
        },
        line: 58
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 51,
            column: 4
          },
          end: {
            line: 53,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 51
      },
      "1": {
        loc: {
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 29
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 51,
            column: 8
          },
          end: {
            line: 51,
            column: 14
          }
        }, {
          start: {
            line: 51,
            column: 18
          },
          end: {
            line: 51,
            column: 29
          }
        }],
        line: 51
      },
      "2": {
        loc: {
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 54,
            column: 4
          },
          end: {
            line: 56,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 54
      },
      "3": {
        loc: {
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 36
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 54,
            column: 8
          },
          end: {
            line: 54,
            column: 22
          }
        }, {
          start: {
            line: 54,
            column: 26
          },
          end: {
            line: 54,
            column: 36
          }
        }],
        line: 54
      },
      "4": {
        loc: {
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 59,
            column: 6
          },
          end: {
            line: 61,
            column: 7
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 59
      },
      "5": {
        loc: {
          start: {
            line: 64,
            column: 11
          },
          end: {
            line: 77,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 65,
            column: 6
          },
          end: {
            line: 67,
            column: 12
          }
        }, {
          start: {
            line: 69,
            column: 6
          },
          end: {
            line: 76,
            column: 10
          }
        }],
        line: 64
      },
      "6": {
        loc: {
          start: {
            line: 70,
            column: 51
          },
          end: {
            line: 70,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 70,
            column: 62
          },
          end: {
            line: 70,
            column: 89
          }
        }, {
          start: {
            line: 70,
            column: 92
          },
          end: {
            line: 70,
            column: 94
          }
        }],
        line: 70
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "f48ba5675c0b0685dbcbb3513c78361bdc46520a"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_23vxb60gl8 = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_23vxb60gl8();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
// if we need to distinguish between same link/name items, we may want
// to look into passing an optional key arg which will be appended

var ICON_NAV_BAR_CLASSES = exports.ICON_NAV_BAR_CLASSES = (cov_23vxb60gl8().s[0]++, {
  active: 'icon-nav-bar-selected',
  disabled: 'icon-nav-bar-disabled',
  icon: 'icon-nav-bar-icon',
  item: 'icon-nav-bar-item',
  link: 'icon-nav-bar-link'
});

/** @deprecated */
var IconNavBar = /*#__PURE__*/function (_Component) {
  _inherits(IconNavBar, _Component);
  function IconNavBar() {
    _classCallCheck(this, IconNavBar);
    return _callSuper(this, IconNavBar, arguments);
  }
  _createClass(IconNavBar, [{
    key: "render",
    value: function render() {
      var _this = this;
      cov_23vxb60gl8().f[0]++;
      cov_23vxb60gl8().s[1]++;
      return /*#__PURE__*/_react["default"].createElement("div", null, this.props.navBarItems.map(function (item) {
        cov_23vxb60gl8().f[1]++;
        cov_23vxb60gl8().s[2]++;
        return _this.renderNavBarIcon(item);
      }));
    }
  }, {
    key: "renderNavBarIcon",
    value: function renderNavBarIcon(navBarItem) {
      var _this2 = this;
      cov_23vxb60gl8().f[2]++;
      var _ref = (cov_23vxb60gl8().s[3]++, navBarItem),
        icon = _ref.icon,
        isActive = _ref.isActive,
        isDisabled = _ref.isDisabled,
        link = _ref.link,
        name = _ref.name,
        render = _ref.render,
        renderDisabled = _ref.renderDisabled;
      var key = (cov_23vxb60gl8().s[4]++, "".concat(link, "-").concat(name));
      var content = (cov_23vxb60gl8().s[5]++, /*#__PURE__*/_react["default"].createElement("div", {
        className: ICON_NAV_BAR_CLASSES.item
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: ICON_NAV_BAR_CLASSES.icon
      }, icon), name));
      cov_23vxb60gl8().s[6]++;
      if ((cov_23vxb60gl8().b[1][0]++, render) && (cov_23vxb60gl8().b[1][1]++, !isDisabled)) {
        cov_23vxb60gl8().b[0][0]++;
        cov_23vxb60gl8().s[7]++;
        return render(navBarItem, content, key);
      } else {
        cov_23vxb60gl8().b[0][1]++;
      }
      cov_23vxb60gl8().s[8]++;
      if ((cov_23vxb60gl8().b[3][0]++, renderDisabled) && (cov_23vxb60gl8().b[3][1]++, isDisabled)) {
        cov_23vxb60gl8().b[2][0]++;
        cov_23vxb60gl8().s[9]++;
        return renderDisabled(navBarItem, content, key);
      } else {
        cov_23vxb60gl8().b[2][1]++;
      }
      cov_23vxb60gl8().s[10]++;
      var handleClick = function handleClick() {
        cov_23vxb60gl8().f[3]++;
        cov_23vxb60gl8().s[11]++;
        if (_this2.props.handleTabChange) {
          cov_23vxb60gl8().b[4][0]++;
          cov_23vxb60gl8().s[12]++;
          _this2.props.handleTabChange(navBarItem);
        } else {
          cov_23vxb60gl8().b[4][1]++;
        }
      };
      cov_23vxb60gl8().s[13]++;
      return isDisabled ? (cov_23vxb60gl8().b[5][0]++, /*#__PURE__*/_react["default"].createElement("div", {
        className: ICON_NAV_BAR_CLASSES.disabled,
        key: key
      }, content)) : (cov_23vxb60gl8().b[5][1]++, /*#__PURE__*/_react["default"].createElement("a", {
        className: "".concat(ICON_NAV_BAR_CLASSES.link, " ").concat(isActive ? (cov_23vxb60gl8().b[6][0]++, ICON_NAV_BAR_CLASSES.active) : (cov_23vxb60gl8().b[6][1]++, '')),
        href: link,
        key: key,
        onClick: handleClick
      }, content));
    }
  }]);
  return IconNavBar;
}(_react.Component);
var _default = exports["default"] = IconNavBar;